import ConfirmAttendenceBlock from './ConfirmAttendenceBlock';
import { ConfirmAttendenceBlockProps, ConfirmAttendenceBlockValueProps } from './types';

export type { ConfirmAttendenceBlockProps, ConfirmAttendenceBlockValueProps };
export default ConfirmAttendenceBlock;
